<template>
    <div>
        <app-data-table
            v-bind="$attrs"
            :fields="fields"
            :on-change-page="onChangePage"
        >
            <template v-slot:created_at="{ item }">
                {{ item.created_at | datetime }}
            </template>
            <template v-slot:require_response="{ item }">
                {{ item.require_response | yesno }}
            </template>
            <template v-slot:actions="{ item }">
                <b-btn size="sm" variant="primary" @click="viewResponses(item)"
                    ><i class="fa fa-comment"></i
                ></b-btn>
            </template>
        </app-data-table>
        <app-pop-up
            size="large"
            :title="`Asunto: ${message.subject}`"
            id="service-spot-message-responses-window"
        >
            <template v-slot:body>
                <b-alert show variant="info" v-if="inProgress"
                    >Cargando...</b-alert
                >
                <app-sub-title
                    text="Información de entregas y respuestas"
                ></app-sub-title>
                <app-data-table
                    v-if="!!message"
                    :items="responses"
                    :fields="responseFields"
                >
                    <template v-slot:delivered_at="{ item }">
                        {{ item.delivered_at | datetime }}
                    </template>
                    <template v-slot:response_at="{ item }">
                        {{ item.response_at | datetime }}
                    </template>
                </app-data-table>
            </template>
        </app-pop-up>
    </div>
</template>
<script>
export default {
    inheritAttrs: false,
    data: () => ({
        fields,
        responseFields,
        message: '',
        responses: [],
    }),
    computed: {},
    methods: {
        async viewResponses(msg) {
            this.$bus.$emit('service-spot-message-responses-window.open')
            this.message = msg
            const { data } = await repo.get(
                `service-spot-messages/${msg.id}/responses`
            )
            this.responses = data
        },
        onChangePage(page) {
            this.$emit('changePage', page)
        },
    },
}

const fields = [
    {
        key: 'created_by.name',
        label: 'Enviado por',
    },
    {
        key: 'subject',
        label: 'Asunto',
    },
    {
        key: 'message',
        label: 'Mensaje',
    },
    {
        key: 'require_response',
        label: 'Con respuesta',
    },
    {
        key: 'created_at',
        label: 'Enviado el',
    },
    {
        key: 'deliveries_count',
        label: 'Entregas',
    },
    {
        key: 'responses_count',
        label: 'Respuestas',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]

const responseFields = [
    {
        key: 'service_spot.venue.client.name',
        label: 'Cliente',
    },
    {
        key: 'service_spot.venue.name',
        label: 'Sede',
    },
    {
        key: 'service_spot.name',
        label: 'Puesto',
    },
    {
        key: 'delivered_to.name',
        label: 'Entregado a',
    },
    {
        key: 'delivered_at',
        label: 'Entregado el',
    },
    {
        key: 'response',
        label: 'Respuesta',
    },
    {
        key: 'response_at',
        label: 'Respuesta el',
    },
]
</script>
